import { PermissionName } from "./permission";

export enum SidebarMenuItem {
  Home = "home",
  GeneralInformation = "general_information",
  Licenses = "licenses",
  Users = "users",
  SubOrganizations = "sub_organizations",
  CreditLog = "credit_log",
  SignOut = "sign_out",

  // Admin tools menu items
  LookupUserData = "lookup_user_data",
  RosterSyncDashboard = "roster_sync_dashboard",
  AuditLogs = "audit_logs",
}

/**
 * All sidebar items, and a list of permissions that lets you access them.
 * If you have at least one of the listed permissions, the feature is available to you.
 * If empty, the feature is available to all users
 */
export const sidebarMenuItemsPermissionRequired: Record<SidebarMenuItem, PermissionName[]> = {
  [SidebarMenuItem.Home]: [],
  [SidebarMenuItem.GeneralInformation]: [],
  [SidebarMenuItem.Licenses]: [PermissionName.ManageOrganizationLicense],
  [SidebarMenuItem.Users]: [PermissionName.ManageUsers],
  [SidebarMenuItem.SubOrganizations]: [PermissionName.CreateChildOrganization, PermissionName.UpdateChildOrganization, PermissionName.DeleteChildOrganization],
  [SidebarMenuItem.CreditLog]: [PermissionName.ViewAuditLogs],
  [SidebarMenuItem.SignOut]: [],
  // Admin tools menu items, no permissions required as /admintools access is limited to system admins anyway
  [SidebarMenuItem.LookupUserData]: [],
  [SidebarMenuItem.RosterSyncDashboard]: [],
  [SidebarMenuItem.AuditLogs]: []
};

// export type SidebarMenuItem = keyof typeof sidebarItemsPermissionRequired;
